import React from 'react';
import {
  Users, Clock, Activity, CheckSquare, UserMinus, XCircle,
  RefreshCw, Award, Home, AlertTriangle, Send,
} from 'lucide-react';
import { CAL } from '@/constants/testIds';

function Metric({ label, value, icon: Icon, tone = 'default', testid }) {
  const toneClass = {
    default: 'text-stone-800',
    warning: 'text-amber-700',
    danger: 'text-red-700',
    success: 'text-emerald-700',
    info: 'text-blue-700',
  }[tone];
  return (
    <div
      data-testid={testid}
      className="flex items-center gap-2.5 px-3 py-1.5 border-r border-stone-200 last:border-r-0 min-w-[110px]"
    >
      <div className={`w-8 h-8 rounded-md bg-stone-50 border border-stone-200 flex items-center justify-center ${toneClass}`}>
        <Icon className="w-4 h-4" />
      </div>
      <div className="leading-tight">
        <div className={`font-heading font-bold text-lg tabular-nums ${toneClass}`}>{value ?? '—'}</div>
        <div className="text-[10px] uppercase tracking-wider text-stone-500">{label}</div>
      </div>
    </div>
  );
}

export default function MetricsHeaderStrip({ metrics }) {
  const m = metrics || {};
  return (
    <div
      className="bg-white border-b border-stone-200 flex items-center overflow-x-auto hc-scrollbar"
      data-testid={CAL.metricsHeader}
    >
      <Metric label="Today"       value={m.total_today}       icon={Users}         testid={CAL.metric('today')} />
      <Metric label="Waiting"     value={m.waiting}           icon={Clock}         tone="warning" testid={CAL.metric('waiting')} />
      <Metric label="In Progress" value={m.in_progress}       icon={Activity}      tone="success" testid={CAL.metric('in-progress')} />
      <Metric label="Completed"   value={m.completed}         icon={CheckSquare}   testid={CAL.metric('completed')} />
      <Metric label="Reminders"   value={m.reminders_pending} icon={Send}          tone="info"    testid={CAL.metric('reminders')} />
      <Metric label="No-Show"     value={m.no_shows}          icon={UserMinus}     tone="danger"  testid={CAL.metric('no-show')} />
      <Metric label="Cancelled"   value={m.cancelled}         icon={XCircle}       tone="danger"  testid={CAL.metric('cancelled')} />
      <Metric label="Follow-ups"  value={m.followups_due}     icon={RefreshCw}     testid={CAL.metric('followups')} />
      <Metric label="Sold"        value={m.sold}              icon={Award}         tone="success" testid={CAL.metric('sold')} />
      <Metric label="Home Visits" value={m.home_visits}       icon={Home}          testid={CAL.metric('home-visits')} />
      <Metric label="High-risk"   value={m.high_risk}         icon={AlertTriangle} tone="warning" testid={CAL.metric('high-risk')} />
    </div>
  );
}
